module.exports = __webpack_public_path__ + "media/images/top/img_pickup_suzuki-b8050c815325aa7f6de2735448ec583d.webp";